/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyMonitoring = {

	delete (context, monitoringId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-monitoring"
			+ "?monitoringId=" + monitoringId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteAttachment (context, monitoringId, index, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-monitoring/attachment"
			+ "?monitoringId=" + monitoringId
			+ "&index=" + index
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, monitoringId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-monitoring"
			+ "?monitoringId=" + monitoringId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAttachment (context, agencyMonitoringId, index, onSuccess, onError, options) {
		Api.get(context,
			"/agency-monitoring/attachment"
			+ "?agencyMonitoringId=" + agencyMonitoringId
			+ "&index=" + index
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-monitoring/configuration"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-monitoring/list"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPossibleUsers (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-monitoring/possible-users"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, agencyProjectId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-monitoring"
			+ "?agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAttachment (context, monitoringId, file, onSuccess, onError, options) {
		Api.post(context,
			"/agency-monitoring/attachment"
			+ "?monitoringId=" + monitoringId
			+ "&file=" + file
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportBySearchCriteria (context, contestId, agencyProjectReportExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-monitoring/export-by-search-criteria"
			+ "?contestId=" + contestId
			, agencyProjectReportExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, monitoringId, data, onSuccess, onError, options) {
		Api.put(context,
			"/agency-monitoring"
			+ "?monitoringId=" + monitoringId
			, data
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, monitoringId, data, onSuccess, onError, options) {
		Api.put(context,
			"/agency-monitoring/finish"
			+ "?monitoringId=" + monitoringId
			, data
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
